import { Command } from "@givenwell/command-palette";
import { MobilePhoneIcon } from "@givenwell/core-solid-icons";

export const devicePreviewCommand: Command = {
  id: "device-preview",
  title: "Open Device Preview",
  icon: <MobilePhoneIcon width="21" />,
  onSelect: () => {
    const path = window.location.pathname;
    // @ts-expect-error
    window.location = `/demo?path=${encodeURIComponent(path)}`;
  },
};
